import classnames from 'classnames'
import * as React from 'react'

import { List, ListProps, useListState } from '../list'
import { Popover, PopoverProps } from '../popover'

export interface SelectListProps extends Omit<PopoverProps, 'onChange'> {
  /**
   * The index of selected item
   */
  selectedIndex?: number

  /**
   * Handler called when selected item in list changes
   */
  onChange: (item: number) => void

  direction?: ListProps['direction']
}

export function SelectList({
  selectedIndex,
  onChange,
  'aria-label': ariaLabel,
  children,
  direction,
  ...props
}: React.PropsWithChildren<SelectListProps>) {
  const listState = useListState({ currentId: null })

  return (
    <Popover {...props} aria-label={ariaLabel} className={classnames(props?.className, 'overflow-y-auto')}>
      <List
        state={listState}
        selectedIndex={selectedIndex}
        className="grow p-1"
        onChange={onChange}
        aria-label={ariaLabel}
        direction={direction}
      >
        {children}
      </List>
    </Popover>
  )
}
